import CardContext from "./CardContext";
import calculateAge from "./calculateAge";
import getAudio from "./getAudio";
import getAssetURL from "./getAssetURL";
import getStatusStyles from "./getStatusStyles";
import humanReadableTime from "./humanReadableTime";
import mapRawData from "./mapRawData";

export {
  CardContext,
  calculateAge,
  getAudio,
  getAssetURL,
  getStatusStyles,
  humanReadableTime,
  mapRawData,
};

export default {
  CardContext,
  calculateAge,
  getAudio,
  getAssetURL,
  getStatusStyles,
  humanReadableTime,
  mapRawData,
};
